import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ProfileUsecase } from '@domain/usecase/profile.usecase';
import { ProfileModel } from '@data/models/profile.model';
import { ActivatedRoute, Router } from '@angular/router';
import { PostModel } from '@data/models/post.model';
import { EventsUsecase } from '@domain/usecase/events.usecase';
import { IEventList } from '@data/interface/events.interface';
import { ReadingHistoryUsecase } from '@domain/usecase/reading-history.usecase';
import tokenHelper from '../../../../common/tokenHelper';
import { PaymentUsecase } from '@domain/usecase/payment.usecase';
import { DialogDetailBadgeComponent } from '../components/dialog-detail-badge/dialog-detail-badge.component';
import { MatDialog } from '@angular/material/dialog';
import { FollowTabEnum } from '@data/enum/follow.enum';
import RoutingConstant from '../../../../app-routing.constant';
import { shortenNumber } from '@common/generalHelper';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
	protected readonly RoutingConstant = RoutingConstant;
	followTabEnum = FollowTabEnum;
	tabs = ['Karya Saya', 'Bacaan', 'Disimpan'];

	activeTabs = 'Bacaan';

	profileDetail: ProfileModel = new ProfileModel();
	publishedPost: PostModel[] = [];
	savedPosts: PostModel[] = [];

	isLoadingEvent = false;
	listEvent: IEventList[] = [];
	username_: any = null;
	badgeUrl:any=null;

	isLoadingReadingHistory = false;
	readingHistory: PostModel[] = [];

	balance = 0;

	constructor(
		public location: Location,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private profileUsecase: ProfileUsecase,
		private router: Router,
		private eventUsecase: EventsUsecase,
		private readingHistoryUsecase: ReadingHistoryUsecase,
		private paymentUsecase: PaymentUsecase
	) { }

	ngOnInit() {
		const username = this.route.snapshot.paramMap.get('username');
		this.username_ = username;

		this.profileUsecase.getDetailProfile(username).subscribe((data: ProfileModel) => {
			this.profileDetail = data;
			this.badgeUrl = data.badges[0]
		});

		this.profileUsecase.getAllPublishedPostBySelf().subscribe((data: PostModel[]) => {
			this.publishedPost = data;
		});

		this.profileUsecase.getBookmarkByUser().subscribe((data) => {
			this.savedPosts = data.bookmarks;
		});

		this.getAllEventRegistered();
		this.getSelfReadingHistory();

		this.paymentUsecase.getBalance().subscribe((response: any) => {
			this.balance = response.balance;
		});
	}

	onClickTabs(value: any) {
		this.activeTabs = value;
	}

	onClickBack() {
		window.history.go(-1);
	}

	getAllEventRegistered() {
		this.isLoadingEvent = true;
		this.eventUsecase.getAllEventRegistered().subscribe(
			(events) => {
				this.isLoadingEvent = false;
				this.listEvent = events;
			},
			(error) => {
				this.isLoadingEvent = false;
			}
		);
	}

	getSelfReadingHistory() {
		this.isLoadingReadingHistory = true;
		const decodedToken = tokenHelper.decodeToken(tokenHelper.getAccessToken() || '');
		this.readingHistoryUsecase.getReadingHistory(decodedToken.username).subscribe((data) => {
			this.readingHistory = data.map((item) => PostModel.fromSimplifiedResponse(item));
		});
	}

	onClickNavigateFollow(type: string) {
		this.router.navigate([`@${this.profileDetail.username}/${type.toLowerCase()}`]);
	}

	detailBadge(data: any) {
		const dialogRef = this.dialog.open(DialogDetailBadgeComponent, {
			width: '400px',
			data
		});
	}

	goToTopup() {
		this.router.navigate([RoutingConstant.TOP_UP]);
	}

	shortenNumber(num: number) {
		return shortenNumber(num)
	}
}
